import { useEffect } from "react";

const STORAGE_KEY_PREFIX = "calendly_scheduled";

const isCalendlyEvent = (e: MessageEvent): boolean => {
  if (typeof e.origin !== "string" || !e.origin.includes("calendly.com")) return false;
  const data = e.data as { event?: string } | null;
  return !!data && typeof data === "object" && data.event === "calendly.event_scheduled";
};

const fireConversion = (locale: "es" | "en") => {
  if (typeof window === "undefined") return;
  const storageKey = `${STORAGE_KEY_PREFIX}_${locale}`;
  if (sessionStorage.getItem(storageKey)) return;

  const gtag = (window as any).gtag;
  if (typeof gtag !== "function") return;

  const conversionLabel =
    locale === "en" ? "1nlvCLq8upEcEInNg51D" : "Qo2DCLb1rZEcEInNg51D";

  gtag("event", "conversion", {
    send_to: `AW-18046051977/${conversionLabel}`,
  });

  const ga4Event = locale === "en" ? "booking_confirmed" : "cita_confirmada";
  gtag("event", ga4Event, {
    value: 1.0,
    currency: "EUR",
  });

  sessionStorage.setItem(storageKey, "1");
};

/**
 * Global listener for Calendly's `event_scheduled` postMessage.
 * Fires GA4 + Ads conversion the instant the booking is confirmed,
 * without relying on the redirect to /cita-confirmada or /en/booking-confirmed.
 * Deduplicated via sessionStorage so the redirect page won't double-fire.
 */
const useCalendlyTracking = () => {
  useEffect(() => {
    const handler = (e: MessageEvent) => {
      if (!isCalendlyEvent(e)) return;
      // FR routes share the Spanish Calendly + ES conversion label
      const path = window.location.pathname;
      const locale: "es" | "en" = path.startsWith("/en") ? "en" : "es";
      fireConversion(locale);
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);
};

export default useCalendlyTracking;
export { STORAGE_KEY_PREFIX as CALENDLY_STORAGE_KEY_PREFIX };
